import jsQR from "jsqr";

export default function useQrScanHook() {
  return {
    captureAndRedirect: async (i: Uint8ClampedArray<ArrayBufferLike>,width:number,height:number) => {
      //return JSON.stringify(i.length)
      try {
        const v = jsQR(i,width,height, {})
        if(v != null){
          const url = v.data
          if(url.indexOf("://cstln.co/") > -1) {
            document.location.href = url
          }
          return JSON.stringify(v.data)
        }
      } catch(err){
        // @ts-expect-error not all errors have a toString method
        if(err.toString) {
          // @ts-expect-error not all errors have a toString method
          return err.toString()
        } else {
          return ""+err
        }
      }
      return "nada"
    }
  };
}

